export default {
  // Navigation
  'nav.about': '회사소개',
  'nav.technology': '기술',
  'nav.products': '제품',
  'nav.contact': '문의',

  // Hero Section
  'hero.subtitle': '스마트 농업을 위한 프리미엄 코코피트',
  'hero.description': '한국 농업기술과 1500년 스리랑카 전통이 만든 최고급 배지 | 최적의 pH와 EC로 수확량 극대화',
  'hero.cta.explore': '제품 둘러보기',
  'hero.cta.contact': '영업 문의',
  'hero.supplier': '공식 공급사 및 권리 보유: Inside Global Co., Ltd.',

  // Brand Story
  'story.title': '1500년 전통의 힘',
  'story.mission': '실론 최고급 코코피트로 수확량을 높이세요',
  'story.paragraph1': '우리의 코코피트는 스리랑카 아가 보디 1세 왕 시대(기원후 5세기)에 조성된 전설적인 농장에서 공급됩니다. 1,500년 이상 세계 최고 품질의 코코넛 섬유를 생산해온 이 역사적인 숲은 탁월한 배지 특성으로 유명합니다.',
  'story.paragraph2': '실론의 독특한 토양 구성과 기후가 만들어낸 프리미엄 코코넛 껍질은 최적의 수분 보유력과 통기성을 자랑하며, 한국 농업대학과의 R&D 협력을 통해 과학적으로 검증된 최고급 배지로 완성됩니다.',
  'story.stat1': '년 이상의 유산',
  'story.stat2': '헥타르 농장',
  'story.stat3': '개 이상의 파트너 농장',

  // Market Leadership
  'market.badge': '글로벌 시장 리더',
  'market.title': '스리랑카 코코넛의 우수성',
  'market.paragraph1': '스리랑카는 19세기 영국 식민지 시대부터 코코넛 기반 제품을 수출해 왔습니다. 수년에 걸쳐 이 산업은 다양한 방식으로 성장하고 발전했으며, 오늘날 스리랑카는 세계에서 네 번째로 큰 코코넛 제품 수출국입니다.',
  'market.paragraph2': '시장 관점에서 볼 때, 여러나라에 스리랑카 코코넛의 수출이 지속적인 높은 점유율의 성장을  기록하고 있습니다.',
  'market.stat.ranking': '글로벌 수출 순위',
  'market.stat.history': '년 이상의 수출 역사',
  'market.chart.title': '스리랑카 수출규모- 코코넛 부문 2020',
  'market.chart.value': '미화 백만 달러 기준',
  'market.chart.confirmed': '2024년 확정치 및 2025년 전망',
  'market.chart.growth': '미국, 유럽 등 주요 시장의 폭발적인 성장세 (+41.83% 전체 성장)',
  'market.chart.coconutCream': '코코넛 크림 급등',
  'market.chart.coconutMilk': '코코넛 밀크 파우더',
  'market.chart.coconutOil': '코코넛 오일',
  'market.chart.topExporter': '1위 수출국: 미국',
  'market.chart.source': '출처: 스리랑카 수출개발청 (2024-2025)',
  'market.chart.countries.usa': '미국',
  'market.chart.countries.germany': '독일',
  'market.chart.countries.netherlands': '네덜란드',
  'market.chart.countries.uk': '영국',
  'market.chart.countries.china': '중국',
  'market.chart.countries.canada': '캐나다',
  'market.chart.countries.japan': '일본',
  'market.chart.countries.australia': '호주',
  'market.chart.countries.india': '인도',
  'market.chart.countries.mexico': '멕시코',

  // Ceylon Heritage Section
  'ceylon.badge': '실론의 유산',
  'ceylon.title': '실론(스리랑카) 코코넛 문화의 발자취',
  'ceylon.summary': '스리랑카는 1,500년 이상 킹코코넛 재배의 중심지였습니다. 몬순기후가 더해진 인도양의 열대 섬으로서 최적의 식물의 생육환경을 가진 스리랑카는 고대부터 코코넛을 재배해왔고,  코코넛의 주요 생산국중 하나입니다.',
  'ceylon.readMore': '전체 내용 보기',
  'ceylon.readLess': '간단히 보기',
  'ceylon.content.intro': '기아와 영양실조를 해소하고 전 세계 식량 안보를 달성하는 것은 인류가 직면한 가장 해결하기 어려운 문제 중 하나입니다. 전 세계 대부분의 사람들이 건강한 식품을 찾지 못하고 있으며, 농업 지식은 소득 창출과 환경 친화적이고 생태학적으로 책임 있는 의사결정 및 생활방식을 통해 환경을 보호하고 천연자원을 지속 가능하게 유지하는 데 핵심적인 역할을 합니다.',
  'ceylon.content.origin': '스리랑카는 인도양에 위치한 열대 섬입니다. 코코넛(Cocos Nucifera)은 고대부터 기원한 것으로 여겨지며, 실론(현 스리랑카) 사람들이 수천 년 동안 재배해 왔습니다. 일부 학자들은 남아시아 또는 남미가 원산지라고 주장하지만, 인도 야자 전문가 베카리(1916-1917)는 코코넛이 남미 원산이라고 결론지었습니다. 그러나 실론에서는 코코넛이 아시아 원산이라고 믿고 있습니다.',
  'ceylon.content.history': '또한, 가장 오래된 기록에 따르면 실론의 코코넛 언급은 파 히안(Fa Hian)이 작성한 것으로 알려져 있습니다. 실론에서 코코넛과 코코넛 아락(술)을 발견했다는 기록이 있습니다. 또한 아랍 상인 이벤 와합(Ibn Wahab)과 아부 세이드(Abu Seyd)은 5세기 A.D.에 실론에 코코넛 아락이 도착했다고 언급했습니다.',
  'ceylon.content.establishment': '따라서 코코넛 야자는 인간의 손이나 자연의 힘에 의해 원래 코코스 누시페라의 고향에서 퍼져나갔을 것으로 추정됩니다. 코코넛 야자의 확산과 전파에 가장 활발한 역할을 한 것은 인간이었을 것입니다.',
  'ceylon.content.king': '문헌 증거에 따르면, 마하완사 왕 아가 보디 1세(Agga Boddhi I)가 A.D. 589년에 코코넛 농장을 조성했다고 합니다. 이것이 실론과 전 세계에서 최초의 코코넛 농장이었을 가능성이 있습니다.',
  'ceylon.content.colonial': '식민지 시대에는 포르투갈, 네덜란드, 영국이 상업적 이익을 위해 코코넛 나무에 더 많은 관심을 기울였습니다. 그 후 코코넛 나무는 스리랑카의 주요 상업 작물 중 하나가 되었으며, 식민지 시대 이후인 1948년에도 점차 그 혜택을 발전시켰습니다.',
  'ceylon.content.present': '그 이후로 스리랑카는 전 세계 인류의 필요를 충족시키기 위해 세계 최고 수준의 다양한 코코넛 기반 제품을 생산하고 수출하고 있습니다.',

  // King Coconut Section
  'kingCoconut.badge': '킹코코넛의 우수성',
  'kingCoconut.title': '킹코코넛 - 스리랑카의 황금 보물',
  'kingCoconut.summary': '킹코코넛(Cocos Nucifera var. Aurantiaca)은 스리랑카 고유의 품종으로, 황금빛 껍질과 탁월한 품질로 전 세계적으로 인정받고 있습니다. 최적의 기후 조건과 1,500년 이상의 재배 노하우가 만들어낸 프리미엄 코코넛입니다.',
  'kingCoconut.readMore': '자세히 보기',
  'kingCoconut.readLess': '간단히 보기',
  'kingCoconut.content.intro': '킹코코넛은 스리랑카에서만 자생하는 특별한 코코넛 품종입니다. 일반 코코넛과 달리 선명한 황금빛 또는 주황빛 껍질을 가지고 있으며, 이는 높은 카로티노이드 함량을 나타냅니다. 스리랑카의 독특한 토양 조성과 열대 몬순 기후가 만들어낸 이 품종은 세계 어디에서도 찾아볼 수 없는 고유한 특성을 지니고 있습니다.',
  'kingCoconut.content.highlight': '킹코코넛은 일반 코코넛보다 섬유질이 더욱 품질하고 리그닌 함량이 높아, 코코피트 배지로 가공했을 때 탁월한 내구성과 구조적 안정성을 제공합니다.',
  'kingCoconut.content.characteristics': '킹코코넛의 껍질은 일반 코코넛보다 두껍고 섬유질이 조밀하게 배열되어 있습니다. 이러한 구조적 특성은 코코피트로 가공 시 우수한 수분 보유력과 통기성을 동시에 제공합니다. 또한 자연적으로 낮은 염분 함량(EC < 0.5 mS/cm)과 이상적인 pH 범위(5.7-6.7)를 유지하여, 별도의 화학적 처리 없이도 최적의 재배 환경을 조성합니다.',
  'kingCoconut.content.cultivation': '스리랑카의 킹코코넛 농장은 대부분 해안 지역과 저지대에 위치하며, 연간 강우량 1,500-2,500mm의 이상적인 기후 조건에서 재배됩니다. 이러한 환경은 코코넛 섬유에 최적의 수분과 영양분을 공급하여, 가공 후에도 우수한 물리적 특성을 유지하게 합니다.',
  'kingCoconut.content.quality': '골든 코코의 모든 제품은 엄선된 킹코코넛만을 사용합니다. 수확 후 즉시 가공하여 섬유의 신선도를 유지하며, 한국 농업대학과의 공동 연구를 통해 개발된 특수 세척 및 완충 공정을 거쳐 최고 품질의 코코피트 배지로 완성됩니다.',
  'kingCoconut.content.conclusion': '킹코코넛의 우수성은 단순히 품종의 차이가 아닙니다. 1,500년 이상 축적된 재배 기술, 스리랑카의 독특한 자연환경, 그리고 현대 농업과학의 결합이 만들어낸 결과입니다. 이것이 바로 골든 코코 제품이 전 세계 농업인들로부터 신뢰받는 이유입니다.',

  // Growing Media Alternatives Section
  'growingMedia.badge': '재배 배지 비교',
  'growingMedia.title': '다양한 재배 배지의 특성',
  'growingMedia.summary': '현대 농업에서 사용되는 다양한 재배 배지들은 각각 고유한 특성과 장단점을 가지고 있습니다. 피트모스, 목재 잔여물, 사탕수수 찌꺼기, 왕겨, 모래, 펄라이트 등 각 배지의 특성을 이해하면 최적의 재배 환경을 선택할 수 있습니다.',
  'growingMedia.readMore': '전체 내용 보기',
  'growingMedia.readLess': '간단히 보기',
  'growingMedia.content.peat.title': '피트 및 피트 유사 재료',
  'growingMedia.content.peat.description': '피트모스는 배수가 잘 되는 지역에서 식물 재료가 축적되어 형성됩니다. 식물 재료의 종류와 분해 정도에 따라 재배 배지로서의 가치가 크게 달라집니다. 전통적으로 널리 사용되어 왔으나, 환경 보호 측면에서 지속 가능한 대안이 필요한 상황입니다.',
  'growingMedia.content.wood.title': '목재 잔여물',
  'growingMedia.content.wood.description': '목재 잔여물은 무토양 재배 배지의 중요한 공급원입니다. 이러한 재료는 일반적으로 목재 산업의 부산물이며 대량으로 쉽게 구할 수 있습니다. 그러나 토양 미생물에 의한 분해 과정에서 질소가 고갈되는 것이 이러한 재료와 관련된 주요 문제 중 하나입니다.',
  'growingMedia.content.bagasse.title': '사탕수수 찌꺼기 (바가스)',
  'growingMedia.content.bagasse.description': '바가스는 제당 산업의 폐기물 부산물입니다. 잘게 썰거나 퇴비화하여 컨테이너 배지의 통기성과 배수 특성을 향상시킬 수 있는 재료를 생산할 수 있습니다. 높은 당 함량으로 인해 배지에 바가스를 혼합한 후 빠른 미생물 활동이 발생합니다.',
  'growingMedia.content.rice.title': '왕겨',
  'growingMedia.content.rice.description': '왕겨는 제분 산업의 부산물입니다. 무게가 매우 가벼우면서도 배수 개선에 매우 효과적입니다. 왕겨의 입자 크기와 분해 저항성은 쌀겨 및 톱밥과 매우 유사합니다. 가볍고 경제적인 장점이 있습니다.',
  'growingMedia.content.sand.title': '모래',
  'growingMedia.content.sand.description': '모래는 토양의 기본 구성 요소로, 중간 및 거친 모래 입자는 컨테이너 배지 질감에 최적의 조정을 제공하는 입자입니다. 배수성과 통기성 개선에 효과적이지만, 무게가 무거운 단점이 있습니다.',
  'growingMedia.content.perlite.title': '펄라이트',
  'growingMedia.content.perlite.description': '펄라이트는 화산 기원의 규산질 광물입니다. 컨테이너 배지에 사용되는 등급은 먼저 분쇄된 다음 결합수가 증발할 때까지 가열되어 가볍고 분말 같은 물질로 팽창됩니다. 가볍고 균일하여 통기성과 배수성 향상에 매우 유용합니다. 펄라이트는 건조할 때 매우 먼지가 많으며 관개 중 컨테이너 상단으로 떠오르는 경향이 있습니다. 또한 펄라이트에는 잠재적으로 독성이 있는 불소가 포함되어 있는 것으로 나타났습니다.',
  'growingMedia.content.vermiculite.title': '버미큘라이트',
  'growingMedia.content.vermiculite.description': '버미큘라이트는 약 745°C로 가열하여 생성되는 판상 운모질 광물입니다. 형성된 팽창된 판상 입자는 매우 높은 수분 보유 늑력과 통기성을 가지고 있습니다. 버미큘라이트는 모래나 펄라이트보다 내구성이 떨어지지만, 칼륨과 마그네슘을 공급할 수 있는 능력이 있습니다. 버미큘라이트는 통기성 측면에서 우수하지만 다공성 구멍의 수가 많기 때문에 일반적으로 토양 혼합물에 사용됩니다.',
  'growingMedia.content.calcined.title': '소성 점토',
  'growingMedia.content.calcined.description': '소성 점토는 몬모릴로나이트 점토 광물을 약 650°C로 가열하여 형성됩니다. 형성된 다공성 판상 입자는 펄라이트보다 약 6배 크기입니다. 소성 점토는 상대적으로 높은 양이온 교환 능력과 수분 보유 능력을 가지고 있습니다. 이러한 무기질 토양 개량제는 일반적으로 다공성 구멍의 수를 늘리기 위해 사용됩니다.',
  'growingMedia.content.polystyrene.title': '발포 폴리스티렌',
  'growingMedia.content.polystyrene.description': '폴리스티렌 플레이크는 폴리스티렌 가공의 부산물로, 분해에 대한 저항성이 매우 높으며 통기성을 증가시키고 배수를 개선하며 벌크 밀도를 감소시킵니다. 폴리스티렌은 고온에 의해 분해될 수 있으며 특정 화학 물질에 의해 분해될 수 있습니다.',
  'growingMedia.content.urea.title': '요소 포름알데히드',
  'growingMedia.content.urea.description': '이 재료는 액체 수지와 혼합하여 냉각시켜 제조됩니다. 요소 포름알데히드 폼은 폴리스티렌보다 수분 보유 늑력이 더 크지만 통기성과 배수에 미치는 영향은 유사합니다.',
  'growingMedia.content.conclusion': '각 재배 배지는 고유한 장단점을 가지고 있습니다. 골든 코코의 코코피트는 이러한 다양한 배지들의 장점을 결합하면서도, 지속 가능성, 일관된 품질, 최적의 물리화학적 특성을 모두 갖춘 프리미엄 솔루션입니다.',

  // Coconut Substrate Importance Section
  'cocoSubstrate.badge': '코코넛 배지의 중요성',
  'cocoSubstrate.title': '재배 배지로서 코코넛 기질의 중요성',
  'cocoSubstrate.summary': '오늘날 재배자와 식물 애호가들의 요구를 충족시키는 고품질의 지속 가능하고 신뢰할 수 있는 재배 배지를 확보하는 것이 그 어느 때보다 중요해졌습니다. 코코넛 코이어(코코피트)가 바로 그 해답입니다.',
  'cocoSubstrate.readMore': '전체 내용 보기',
  'cocoSubstrate.readLess': '간단히 보기',
  'cocoSubstrate.content.intro': '코코 코이어는 모든 식물에 이상적인 유기 기반을 제공하며, 열대 기후에서 품부하게 자라는 천연 재생 가능한 자원으로 100% 생분해가 가능하며, 과거의 일반적인 배지 옵션과는 달리 환경 친화적입니다.',
  'cocoSubstrate.content.processing': '코코넛의 외피 또는 껍질은 수세기 동안 대부분의 코코 코이어가 생산되는 밧줄, 빗자루, 매트로 제분되어 버려졌습니다. 그 후 코코 피트를 발견하여 강력하고 재사용 가능한 식물 배지로서의 능력을 발견했습니다.',
  'cocoSubstrate.content.structure': '코코 피트는 식물의 뿌리 시스템이 필요로 하는 통기성과 수분 보유력을 제공하는 다면적인 토양 컨디셔너로, 모세관 미세 스펀지로 구성되어 있습니다. 이러한 미세 스펀지는 수분 보유 능력을 유지하면서 압축되거나 수축되지 않으며, 정밀한 재배 환경을 제공합니다.',
  'cocoSubstrate.content.properties': '코코 피트는 균질한 재료이며 안전하게 재활용하여 토양 조건을 개선할 수 있습니다. 성장 주기 동안 압축되거나 수축되는 능력이 없으며, 코이어는 탁월한 구조적 지원을 제공하여 식물 성장 중 분해에 저항하여 정밀한 재배 환경을 제공합니다.',
  'cocoSubstrate.content.physical': '물리적 특성은 성장 주기 동안 압축되거나 수축되는 능력을 유지하지 않으며, 코이어는 식물 성장 중 분해에 저항하는 탁월한 구조적 지원을 제공합니다. 또한 코이어는 비용이 많이 드는 폐기 관행을 피하면서 환경을 해치지 않고 토양 조건을 개선하기 위해 환경으로 안전하게 재활용될 수 있습니다.',
  'cocoSubstrate.content.srilanka': '스리랑카 코코넛 기질이 매우 중요한 이유는 다른 코코넛 기질 수출 국가와 달리 가치 추가 없이 원자재를 제조 공정으로 직접 전달하기 때문입니다. 따라서 우리 모국 토양의 pH, EC 수준이 제조에 매우 일치하여 100% 유기농이며 원자재에서 제조 공정으로 직접 전달됩니다.',
  'cocoSubstrate.content.blessing': '이것이 바로 우리가 자연의 축복으로 여기는 이유입니다.',
  'cocoSubstrate.content.conclusion': '골든 코코의 코코피트는 단순한 재배 배지가 아닙니다. 1,500년 스리랑카 전통, 최적의 자연환경, 그리고 한국 농업과학의 결합으로 탄생한 프리미엄 솔루션입니다. 지속 가능하면서도 최고의 성능을 제공하는 차세대 재배 배지를 경험하세요.',

  // Certifications & Quality Assurance Section
  'certification.badge': '국제 인증 및 품질 보증',
  'certification.title': '검증된 품질, 신뢰할 수 있는 파트너',
  'certification.description': '모든 Golden Coco 제품은 국제 식물 검역 기준을 충족하며, 엄격한 품질 관리 시스템을 통해 생산됩니다. 훈증 인증서는 제품이 안전하고 해충이 없음을 보증합니다.',
  'certification.fumigation.title': '훈증 인증서',
  'certification.fumigation.description': 'Ceylon Pest Control Co. (Private) Limited의 공식 훈증 인증서로, 모든 제품이 국제 식물 검역 기준에 따라 처리되었음을 증명합니다.',
  'certification.pestFree.title': '무해충 보증',
  'certification.pestFree.description': 'Methyl Bromide를 사용한 전문 훈증 처리로 모든 해충을 완전히 제거하여 수입국의 검역 기준을 충족합니다.',
  'certification.international.title': '국제 표준 준수',
  'certification.international.description': 'IPPC(국제식물보호협약) 기준을 완벽하게 준수하여 한국을 포함한 전 세계 모든 국가로 안전하게 수출 가능합니다.',
  'certification.phytosanitary.title': '식물 검역 인증서',
  'certification.phytosanitary.subtitle': 'Ceylon Pest Control Co. 공식 인증',
  'certification.phytosanitary.standards.title': '국제 식물 검역 기준 준수',
  'certification.phytosanitary.standards.desc': 'IPPC(국제식물보호협약) 기준에 따라 모든 제품이 처리되었음을 인증합니다.',
  'certification.phytosanitary.fumigation.title': '전문 훈증 처리',
  'certification.phytosanitary.fumigation.desc': 'Methyl Bromide를 사용한 전문 훈증 처리로 모든 해충을 완전히 제거합니다.',
  'certification.phytosanitary.export.title': '전 세계 수출 가능',
  'certification.phytosanitary.export.desc': '한국을 포함한 전 세계 모든 국가로 안전하게 수출 가능합니다.',
  'certification.phytosanitary.documentation.title': '완전한 문서화',
  'certification.phytosanitary.documentation.desc': '모든 출하 제품에 공식 인증서가 제공되어 안심',
  'certification.phytosanitary.certified': 'Ceylon Pest Control Co. 공식 인증',
  'certification.stats.safety': '품질 보증',
  'certification.stats.iso': '유기농 인증',
  'certification.stats.processing': '시간 처리',
  'certification.stats.processingLabel': '처리 시간',
  'certification.stats.description': '모든 출하 제품에 훈증 인증서 제공으로 안심',
  'certification.quality.lab': '실험실 검증',
  'certification.quality.labDesc': '모든 배치 테스트',
  'certification.quality.assurance': '품질 보증',
  'certification.quality.assuranceDesc': '엄격한 QC 시스템',
  'certification.quality.eco': '친환경 처리',
  'certification.quality.ecoDesc': '환경 안전 기준 준수',
  'certification.quality.documentation': '완전한 문서화',
  'certification.quality.documentationDesc': '모든 인증서 제공',

  // Technology Section
  'tech.subtitle': '왜 골든 코코인가',
  'tech.title.line1': '과학이 만나는',
  'tech.title.line2': '전통',
  'tech.superiority.title': '기술적 우수성',
  'tech.superiority.water.title': '수분 보유력',
  'tech.superiority.water.description': '구조적 안정성을 유지하면서 최대 수분 보유 능력 발휘',
  'tech.superiority.air.title': '공기 보유력 (AFP)',
  'tech.superiority.air.description': '포화 상태에서',
  'tech.superiority.chemical.title': '화학적 균형',
  'tech.superiority.quote': '"한국 기술로 완성된 품질 – 선도적인 한국 농업대학과의 지속적인 R&D를 통해 최적의 pH와 EC 수준을 보장하여 우수한 작물 성능을 실현합니다."',
  'tech.ph.title': '완벽한 pH 균형',
  'tech.ph.description': '모든 작물에 최적화된 pH 범위로 영양소 흡수율을 극대화합니다. 성장 주기 내내 안정적인 pH를 유지하여 관리 비용을 절감하고 수확량을 높입니다.',
  'tech.ec.title': '초저 EC',
  'tech.ec.description': '매우 낮은 전기전도도로 어린 뿌리를 염분 스트레스로부터 완벽하게 보호합니다. 묘목부터 안전하게 사용 가능하며 정밀한 영양소 제어로 건강한 성장을 보장합니다.',
  'tech.durability.title': '탁월한 내구성',
  'tech.durability.value': '3년 이상',
  'tech.durability.description': '높은 리그닌 함량으로 조기 분해를 방지하여 장기간 사용이 가능합니다. 여러 시즌 동안 구조와 통기성을 유지하여 투자 대비 최고의 가치를 제공합니다.',
  'tech.learnMore': '자세히 보기',
  'tech.showLess': '간단히 보기',
  'tech.ph.detail.title': 'pH 균형의 중요성',
  'tech.ph.detail.p1': '5.7-6.7의 pH 범위는 대부분의 상업용 작물에 이상적인 영양소 흡수 환경을 제공합니다. 이 범위에서 질소, 인, 칼륨 등 주요 영양소의 가용성이 최대화됩니다.',
  'tech.ph.detail.p2': '한국 농업대학과의 협력 연구를 통해 개발된 우리의 완충 시스템은 관개수의 pH 변화에도 안정적인 근권 환경을 유지합니다.',
  'tech.ph.detail.benefits': '주요 이점',
  'tech.ph.detail.benefit1': '영양소 흡수율 최대 30% 향상',
  'tech.ph.detail.benefit2': 'pH 조정 비용 최대 50% 절감',
  'tech.ph.detail.benefit3': '작물 품질 및 수확량 증대',
  'tech.ec.detail.title': '저 EC의 장점',
  'tech.ec.detail.p1': '0.5 mS/cm 미만의 초저 EC는 염분 축적 위험을 최소화하여 민감한 작물도 안전하게 재배할 수 있습니다.',
  'tech.ec.detail.p2': '깨끗한 시작점을 제공하여 재배자가 작물의 성장 단계에 맞춰 정밀하게 영양소를 관리할 수 있습니다.',
  'tech.ec.detail.benefits': '주요 이점',
  'tech.ec.detail.benefit1': '염분 스트레스 제로로 건강한 뿌리 발달',
  'tech.ec.detail.benefit2': '정밀 영양 관리로 최적 성장 실현',
  'tech.ec.detail.benefit3': '묘목부터 안전하게 사용 가능',
  'tech.durability.detail.title': '장기 내구성',
  'tech.durability.detail.p1': '높은 리그닌 함량(45% 이상)은 미생물 분해에 대한 저항성을 높여 3년 이상 구조적 안정성을 유지합니다.',
  'tech.durability.detail.p2': '장기간 사용해도 통기성과 배수성이 유지되어 지속적으로 우수한 재배 환경을 제공합니다.',
  'tech.durability.detail.benefits': '주요 이점',
  'tech.durability.detail.benefit1': '3년 이상 사용 가능하여 비용 절감',
  'tech.durability.detail.benefit2': '장기간 안정적인 물리적 특성 유지',
  'tech.durability.detail.benefit3': '교체 주기 연장으로 노동력 절감',

  // Products Section
  'products.title': '프리미엄 제품 라인업',
  'products.filter.all': '전체',
  'products.filter.hydroponics': '수경재배',
  'products.filter.nursery': '육묘',
  'products.filter.gardening': '원예',
  'products.badge.bestseller': '베스트셀러',
  'products.cta.details': '상세 정보 보기',
  'products.cta.learn': '자세히 알아보기',
  'products.card.badge.bestseller': '베스트셀러',
  'products.card.badge.organic': '100% 유기농',
  'products.card.badge.floriculture': '화훼 및 어린 식물',
  'products.card.badge.soilAmendment': '토양 개량제',
  'products.card.badge.plantSupport': '식물 지지대',
  'products.card.cta.inquiry': '제품 문의하기',
  'products.card.cta.learnMore': '자세히 알아보기',

  // Product Details
  'product.growbags.name': '프리미엄 그로우백',
  'product.growbags.description': '토마토, 파프리카, 딸기 수경재배에 최적화된 프리미엄 배지. 수확량 증대 보장',
  'product.growcube.name': '유기농 그로우 큐브',
  'product.growcube.description': '100% 유기농 생분해성 육묘 배지. 건강한 뿌리 발달로 정착률 향상',
  'product.growdisk.name': '그로우 디스크',
  'product.growdisk.description': '화훼 및 소형 식물을 위한 전문 배지',
  'product.cocobrick.name': '압축 코코 브릭',
  'product.cocobrick.description': '60-70L로 팽창하는 프리미엄 토양 개량제. 경제적이고 보관 편리',
  'product.growpole.name': '코코 그로우 폴',
  'product.growpole.description': '몬스테라와 덩굴 식물을 위한 천연 지지대',

  // Grow Bags Detail
  'product.growbags.detail.overview.badge': '수경재배 전문',
  'product.growbags.detail.overview.title': '상업용 수경재배를 위한 최고의 선택',
  'product.growbags.detail.overview.description': '토마토, 파프리카, 딸기 등 상업용 수경재배에 최적화된 프리미엄 그로우백입니다. 한국 농업대학과의 공동 연구로 개발된 맞춤형 배합으로 수확량을 극대화하고, 안정적인 pH와 EC로 관리가 쉽습니다.',
  'product.growbags.detail.learnMore': '상세 정보 보기',
  'product.growbags.detail.showLess': '간단히 보기',
  'product.growbags.detail.features.title': '주요 특징',
  'product.growbags.detail.features.optimal': '수경재배 최적화',
  'product.growbags.detail.features.optimalDesc': '토마토, 파프리카, 딸기 등 상업용 수경재배에 최적화된 배합',
  'product.growbags.detail.features.custom': '맞춤형 배합',
  'product.growbags.detail.features.customDesc': '작물별 특성에 맞춘 칩/더스트 비율 조정 가능',
  'product.growbags.detail.features.chipSize': '칩 크기 조절',
  'product.growbags.detail.features.chipSizeDesc': '7mm, 9mm, 10mm 등 다양한 칩 크기 선택 가능',
  'product.growbags.detail.features.organic': '100% 유기농',
  'product.growbags.detail.features.organicDesc': '화학 처리 없는 천연 코코넛 섬유만 사용',
  'product.growbags.detail.features.eco': '친환경',
  'product.growbags.detail.features.ecoDesc': '생분해 가능하며 재활용하여 토양 개량제로 사용 가능',
  'product.growbags.detail.features.growth': '성장률 향상',
  'product.growbags.detail.features.growthDesc': '최적의 근권 환경으로 작물 성장 속도 증가',
  'product.growbags.detail.features.water': '우수한 수분 보유력',
  'product.growbags.detail.features.waterDesc': '균일한 수분 분포로 안정적인 재배 환경 제공',
  'product.growbags.detail.features.ph': '안정적인 pH',
  'product.growbags.detail.features.phDesc': 'pH 5.7-6.7 범위로 영양소 흡수 최적화',
  'product.growbags.detail.features.ec': '초저 EC',
  'product.growbags.detail.features.ecDesc': 'EC < 0.5 mS/cm로 염분 스트레스 제로',
  'product.growbags.detail.features.drainage': '탁월한 배수성',
  'product.growbags.detail.features.drainageDesc': '과습 방지로 뿌리 건강 유지',
  'product.growbags.detail.features.greenhouse': '온실 재배 최적',
  'product.growbags.detail.features.greenhouseDesc': '온실 환경에 최적화된 물리적 특성',
  'product.growbags.detail.features.drainageSlits': '배수 슬릿',
  'product.growbags.detail.features.drainageSlitsDesc': '과잉 수분 배출을 위한 배수 슬릿 포함',
  'product.growbags.detail.features.plantingHoles': '식재 홀',
  'product.growbags.detail.features.plantingHolesDesc': '작물 식재를 위한 홀 사전 가공 가능',
  'product.growbags.detail.features.dripHoles': '점적 홀',
  'product.growbags.detail.features.dripHolesDesc': '점적 관수 시스템을 위한 홀 포함',
  'product.growbags.detail.specs.title': '기술 사양',
  'product.growbags.detail.specs.standardSizes': '표준 크기',
  'product.growbags.detail.specs.customAvailable': '맞춤 크기 제작 가능',
  'product.growbags.detail.specs.phRange': 'pH 범위',
  'product.growbags.detail.specs.ec': 'EC 수준',
  'product.growbags.detail.specs.chipSize': '칩 크기',
  'product.growbags.detail.specs.mixRatio': '배합 비율',
  'product.growbags.detail.specs.mixRatioValue': '맞춤 제작',
  'product.growbags.detail.specs.waterRetention': '수분 보유력',
  'product.growbags.detail.specs.waterRetentionValue': '높음',
  'product.growbags.detail.specs.certification': '인증',
  'product.growbags.detail.specs.certificationValue': '유기농',
  'product.growbags.detail.applications.title': '적용 분야',
  'product.growbags.detail.applications.tomato': '토마토',
  'product.growbags.detail.applications.pepper': '파프리카',
  'product.growbags.detail.applications.strawberry': '딸기',
  'product.growbags.detail.applications.cucumber': '오이',
  'product.growbags.detail.applications.eggplant': '가지',
  'product.growbags.detail.applications.chili': '고추',
  'product.growbags.detail.applications.berries': '베리류',
  'product.growbags.detail.applications.floriculture': '화훼',
  'product.growbags.detail.why.title': '왜 골든 코코를 선택해야 하나요?',
  'product.growbags.detail.why.hydroponics.title': '수경재배 전문:',
  'product.growbags.detail.why.hydroponics.desc': '상업용 수경재배에 최적화된 배합으로 수확량을 극대화합니다.',
  'product.growbags.detail.why.premium.title': '프리미엄 품질:',
  'product.growbags.detail.why.premium.desc': '스리랑카 킹코코넛만을 사용한 최고급 배지입니다.',
  'product.growbags.detail.why.korean.title': '한국 기술:',
  'product.growbags.detail.why.korean.desc': '한국 농업대학과의 공동 연구로 개발된 과학적 배합입니다.',
  'product.growbags.detail.why.proven.title': '검증된 성능:',
  'product.growbags.detail.why.proven.desc': '전국 농가에서 검증된 안정적인 수확량 증대 효과를 제공합니다.',
  'product.growbags.detail.why.custom.title': '맞춤형 솔루션:',
  'product.growbags.detail.why.custom.desc': '작물과 재배 환경에 맞춘 맞춤형 배합이 가능합니다.',
  'product.growbags.detail.why.sustainable.title': '지속 가능:',
  'product.growbags.detail.why.sustainable.desc': '환경 친화적이며 재활용 가능한 천연 재료입니다.',
  'product.growbags.detail.why.cost.title': '비용 효율:',
  'product.growbags.detail.why.cost.desc': '장기 사용 가능하여 투자 대비 최고의 가치를 제공합니다.',
  'product.growbags.detail.why.quote': '"골든 코코 그로우백으로 수확량을 극대화하고 안정적인 수익을 실현하세요"',

  // Grow Cube Detail
  'product.growcube.detail.card.description': '어린 식물을 위한 100% 유기농 생분해성 배지',
  'product.growcube.detail.card.organic': '유기농',
  'product.growcube.detail.card.biodegradable': '생분해',
  'product.growcube.detail.card.eco': '친환경',
  'product.growcube.detail.overview.badge': '육묘 전문',
  'product.growcube.detail.overview.title': '건강한 뿌리 발달을 위한 최적의 선택',
  'product.growcube.detail.overview.description': '100% 유기농 생분해성 육묘 배지로, 어린 식물의 건강한 뿌리 발달을 촉진합니다. 균일한 수분 분포와 우수한 통기성으로 정착률을 높이고, 이식 후 스트레스를 최소화합니다.',
  'product.growcube.detail.learnMore': '상세 정보 보기',
  'product.growcube.detail.showLess': '간단히 보기',
  'product.growcube.detail.features.title': '주요 특징',
  'product.growcube.detail.features.optimal': '육묘 최적화',
  'product.growcube.detail.features.optimalDesc': '어린 식물의 건강한 뿌리 발달에 최적화된 배지',
  'product.growcube.detail.features.organic': '100% 유기농',
  'product.growcube.detail.features.organicDesc': '화학 처리 없는 천연 코코넛 섬유만 사용',
  'product.growcube.detail.features.biodegradable': '생분해성',
  'product.growcube.detail.features.biodegradableDesc': '환경 친화적이며 완전히 생분해 가능',
  'product.growcube.detail.features.water': '균일한 수분 분포',
  'product.growcube.detail.features.waterDesc': '모든 부분에 균일한 수분 공급으로 안정적인 성장',
  'product.growcube.detail.features.rootGrowth': '뿌리 발달 촉진',
  'product.growcube.detail.features.rootGrowthDesc': '우수한 통기성으로 건강한 뿌리 성장 지원',
  'product.growcube.detail.features.greenhouse': '온실 재배 최적',
  'product.growcube.detail.features.greenhouseDesc': '온실 육묘 환경에 최적화된 물리적 특성',
  'product.growcube.detail.features.drainage': '탁월한 배수성',
  'product.growcube.detail.features.drainageDesc': '과습 방지로 뿌리 건강 유지',
  'product.growcube.detail.features.fastRoot': '빠른 뿌리 활착',
  'product.growcube.detail.features.fastRootDesc': '이식 후 빠른 정착으로 스트레스 최소화',
  'product.growcube.detail.features.dripHoles': '점적 홀',
  'product.growcube.detail.features.dripHolesDesc': '점적 관수 시스템을 위한 홀 포함',
  'product.growcube.detail.specs.title': '기술 사양',
  'product.growcube.detail.specs.standardSize': '표준 크기',
  'product.growcube.detail.specs.phRange': 'pH 범위',
  'product.growcube.detail.specs.ec': 'EC 수준',
  'product.growcube.detail.specs.waterRetention': '수분 보유력',
  'product.growcube.detail.specs.waterRetentionValue': '높음',
  'product.growcube.detail.specs.aeration': '통기성',
  'product.growcube.detail.specs.aerationValue': '우수',
  'product.growcube.detail.specs.certification': '인증',
  'product.growcube.detail.specs.certificationValue': '유기농',
  'product.growcube.detail.applications.title': '적용 분야',
  'product.growcube.detail.applications.nursery': '육묘장',
  'product.growcube.detail.applications.greenhouse': '온실 재배',
  'product.growcube.detail.applications.hydroponics': '수경재배',
  'product.growcube.detail.applications.organic': '유기농 재배',
  'product.growcube.detail.applications.urban': '도시 농업',
  'product.growcube.detail.applications.research': '연구 기관',
  'product.growcube.detail.why.title': '왜 골든 코코를 선택해야 하나요?',
  'product.growcube.detail.why.premium.title': '프리미엄 품질:',
  'product.growcube.detail.why.premium.desc': '스리랑카 킹코코넛만을 사용한 최고급 육묘 배지입니다.',
  'product.growcube.detail.why.tradition.title': '전통과 과학:',
  'product.growcube.detail.why.tradition.desc': '1,500년 전통과 현대 농업과학의 완벽한 결합입니다.',
  'product.growcube.detail.why.sustainable.title': '지속 가능:',
  'product.growcube.detail.why.sustainable.desc': '100% 생분해 가능한 친환경 재료입니다.',
  'product.growcube.detail.why.proven.title': '검증된 성능:',
  'product.growcube.detail.why.proven.desc': '전국 육묘장에서 검증된 높은 정착률을 자랑합니다.',
  'product.growcube.detail.why.custom.title': '맞춤형 솔루션:',
  'product.growcube.detail.why.custom.desc': '작물 특성에 맞춘 맞춤형 크기와 배합이 가능합니다.',
  'product.growcube.detail.why.quote': '"골든 코코 그로우 큐브로 건강한 묘목을 키우고 성공적인 재배를 시작하세요"',

  // Grow Disk Detail
  'product.growdisk.detail.card.multipurpose': '다용도',
  'product.growdisk.detail.overview.badge': '화훼 전문',
  'product.growdisk.detail.overview.title': '화훼 및 소형 식물 재배를 위한 최적의 선택',
  'product.growdisk.detail.overview.description': '거베라, 장미 등 화훼 재배에 최적화된 전문 배지입니다. 빠른 배수와 우수한 통기성으로 뿌리 건강을 유지하며, 맞춤형 배합으로 다양한 화훼 작물에 적용 가능합니다.',
  'product.growdisk.detail.learnMore': '상세 정보 보기',
  'product.growdisk.detail.showLess': '간단히 보기',
  'product.growdisk.detail.features.title': '주요 특징',
  'product.growdisk.detail.features.optimal': '화훼 최적화',
  'product.growdisk.detail.features.optimalDesc': '거베라, 장미 등 화훼 재배에 최적화된 전문 배지',
  'product.growdisk.detail.features.versatile': '다용도',
  'product.growdisk.detail.features.versatileDesc': '다양한 화훼 및 소형 식물에 적용 가능',
  'product.growdisk.detail.features.custom': '맞춤형 배합',
  'product.growdisk.detail.features.customDesc': '작물별 특성에 맞춘 칩/더스트 비율 조정 가능',
  'product.growdisk.detail.features.chipSize': '칩 크기 조절',
  'product.growdisk.detail.features.chipSizeDesc': '작물 특성에 맞는 다양한 칩 크기 선택 가능',
  'product.growdisk.detail.features.organic': '100% 유기농',
  'product.growdisk.detail.features.organicDesc': '화학 처리 없는 천연 코코넛 섬유만 사용',
  'product.growdisk.detail.features.eco': '친환경',
  'product.growdisk.detail.features.ecoDesc': '생분해 가능하며 재활용하여 토양 개량제로 사용 가능',
  'product.growdisk.detail.features.growth': '성장률 향상',
  'product.growdisk.detail.features.growthDesc': '최적의 근권 환경으로 작물 성장 속도 증가',
  'product.growdisk.detail.features.water': '우수한 수분 보유력',
  'product.growdisk.detail.features.waterDesc': '균일한 수분 분포로 안정적인 재배 환경 제공',
  'product.growdisk.detail.features.air': '탁월한 통기성',
  'product.growdisk.detail.features.airDesc': '뿌리 호흡을 위한 충분한 공기 공급',
  'product.growdisk.detail.features.ph': '안정적인 pH',
  'product.growdisk.detail.features.phDesc': 'pH 5.7-6.7 범위로 영양소 흡수 최적화',
  'product.growdisk.detail.features.ec': '초저 EC',
  'product.growdisk.detail.features.ecDesc': 'EC < 0.5 mS/cm로 염분 스트레스 제로',
  'product.growdisk.detail.features.drainage': '빠른 배수',
  'product.growdisk.detail.features.drainageDesc': '과습 방지로 뿌리 건강 유지',
  'product.growdisk.detail.features.greenhouse': '온실 재배 최적',
  'product.growdisk.detail.features.greenhouseDesc': '온실 환경에 최적화된 물리적 특성',
  'product.growdisk.detail.features.drainageSlits': '배수 슬릿',
  'product.growdisk.detail.features.drainageSlitsDesc': '과잉 수분 배출을 위한 배수 슬릿 포함',
  'product.growdisk.detail.features.plantingHoles': '식재 홀',
  'product.growdisk.detail.features.plantingHolesDesc': '작물 식재를 위한 홀 사전 가공 가능',
  'product.growdisk.detail.features.dripHoles': '점적 홀',
  'product.growdisk.detail.features.dripHolesDesc': '점적 관수 시스템을 위한 홀 포함',
  'product.growdisk.detail.specs.title': '기술 사양',
  'product.growdisk.detail.specs.standardSize': '표준 크기',
  'product.growdisk.detail.specs.customSize': '맞춤 제작',
  'product.growdisk.detail.specs.phRange': 'pH 범위',
  'product.growdisk.detail.specs.ec': 'EC 수준',
  'product.growdisk.detail.specs.drainage': '배수 속도',
  'product.growdisk.detail.specs.drainageValue': '빠름',
  'product.growdisk.detail.specs.aeration': '통기성',
  'product.growdisk.detail.specs.aerationValue': '우수',
  'product.growdisk.detail.specs.application': '적용 분야',
  'product.growdisk.detail.specs.applicationValue': '화훼 및 소형 식물',
  'product.growdisk.detail.applications.title': '적용 분야',
  'product.growdisk.detail.applications.floriculture': '화훼 재배',
  'product.growdisk.detail.applications.smallPlants': '소형 식물',
  'product.growdisk.detail.applications.cannabis': '대마초',
  'product.growdisk.detail.applications.vegetables': '채소',
  'product.growdisk.detail.applications.fruits': '과일',
  'product.growdisk.detail.applications.greenhouse': '온실 재배',
  'product.growdisk.detail.why.title': '왜 골든 코코를 선택해야 하나요?',
  'product.growdisk.detail.why.versatile.title': '다용도 솔루션:',
  'product.growdisk.detail.why.versatile.desc': '다양한 화훼 및 소형 식물에 적용 가능한 범용 배지입니다.',
  'product.growdisk.detail.why.premium.title': '프리미엄 품질:',
  'product.growdisk.detail.why.premium.desc': '스리랑카 킹코코넛만을 사용한 최고급 배지입니다.',
  'product.growdisk.detail.why.korean.title': '한국 기술:',
  'product.growdisk.detail.why.korean.desc': '한국 농업대학과의 공동 연구로 개발된 과학적 배합입니다.',
  'product.growdisk.detail.why.proven.title': '검증된 성능:',
  'product.growdisk.detail.why.proven.desc': '전국 화훼 농가에서 검증된 안정적인 품질을 제공합니다.',
  'product.growdisk.detail.why.custom.title': '맞춤형 솔루션:',
  'product.growdisk.detail.why.custom.desc': '작물과 재배 환경에 맞춘 맞춤형 배합이 가능합니다.',
  'product.growdisk.detail.why.sustainable.title': '지속 가능:',
  'product.growdisk.detail.why.sustainable.desc': '환경 친화적이며 재활용 가능한 천연 재료입니다.',
  'product.growdisk.detail.why.quote': '"골든 코코 그로우 디스크로 아름다운 화훼를 재배하세요"',

  // Coco Brick Detail
  'product.cocobrick.detail.card.ph': 'pH 수준',
  'product.cocobrick.detail.card.ec': 'EC 수준',
  'product.cocobrick.detail.overview.badge': '토양 개량',
  'product.cocobrick.detail.overview.title': '프리미엄 토양 개량 솔루션',
  'product.cocobrick.detail.overview.description': '60-70L로 팽창하는 압축 코코 브릭으로, 토양 구조 개선과 수분 보유력 향상에 탁월합니다. 경제적이고 보관이 편리하며, 다양한 원예 및 농업 용도로 사용 가능합니다.',
  'product.cocobrick.detail.learnMore': '상세 정보 보기',
  'product.cocobrick.detail.showLess': '간단히 보기',
  'product.cocobrick.detail.features.title': '주요 특징',
  'product.cocobrick.detail.features.soilMix': '60-70L로 팽창하여 토양과 혼합 사용',
  'product.cocobrick.detail.features.versatile': '다양한 원예 및 농업 용도로 사용 가능',
  'product.cocobrick.detail.features.mixRatio': '토양과 1:1 또는 1:2 비율로 혼합 권장',
  'product.cocobrick.detail.features.chipSize': '다양한 칩 크기 선택 가능',
  'product.cocobrick.detail.features.organic': '100% 유기농 천연 재료',
  'product.cocobrick.detail.features.eco': '환경 친화적이며 재활용 가능',
  'product.cocobrick.detail.features.disposal': '사용 후 토양 개량제로 재활용',
  'product.cocobrick.detail.features.growth': '식물 성장률 향상',
  'product.cocobrick.detail.features.water': '우수한 수분 보유력',
  'product.cocobrick.detail.features.air': '탁월한 통기성',
  'product.cocobrick.detail.features.ph': '안정적인 pH 5.7-6.7',
  'product.cocobrick.detail.features.ec': '초저 EC < 0.5 mS/cm',
  'product.cocobrick.detail.features.drainage': '탁월한 배수성',
  'product.cocobrick.detail.features.greenhouse': '온실 재배 최적',
  'product.cocobrick.detail.features.custom': '맞춤형 크기 및 배합 가능',
  'product.cocobrick.detail.specs.title': '기술 사양',
  'product.cocobrick.detail.specs.standardSize': '표준 크기',
  'product.cocobrick.detail.specs.standardSizeDesc': '5kg 압축 브릭 (60-70L로 팽창)',
  'product.cocobrick.detail.specs.phRange': 'pH 범위',
  'product.cocobrick.detail.specs.phRangeDesc': '5.7 - 6.7',
  'product.cocobrick.detail.specs.ec': 'EC 수준',
  'product.cocobrick.detail.specs.ecDesc': '< 0.5 mS/cm',
  'product.cocobrick.detail.specs.chipSize': '칩 크기',
  'product.cocobrick.detail.specs.chipSizeDesc': '다양한 크기 선택 가능',
  'product.cocobrick.detail.specs.mixRatio': '혼합 비율',
  'product.cocobrick.detail.specs.mixRatioDesc': '토양과 1:1 또는 1:2',
  'product.cocobrick.detail.specs.certification': '인증',
  'product.cocobrick.detail.specs.certificationDesc': '유기농 인증',
  'product.cocobrick.detail.applications.title': '적용 분야',
  'product.cocobrick.detail.applications.soilImprovement': '토양 개량',
  'product.cocobrick.detail.applications.soilImprovementDesc': '토양 구조 개선',
  'product.cocobrick.detail.applications.nursery': '육묘장',
  'product.cocobrick.detail.applications.nurseryDesc': '육묘 배지',
  'product.cocobrick.detail.applications.homeGardening': '가정 원예',
  'product.cocobrick.detail.applications.homeGardeningDesc': '화분 재배',
  'product.cocobrick.detail.applications.greenhouse': '온실 재배',
  'product.cocobrick.detail.applications.greenhouseDesc': '상업용 재배',
  'product.cocobrick.detail.applications.landscaping': '조경',
  'product.cocobrick.detail.applications.landscapingDesc': '정원 조성',
  'product.cocobrick.detail.applications.research': '연구 기관',
  'product.cocobrick.detail.applications.researchDesc': '실험 재배',
  'product.cocobrick.detail.why.title': '왜 골든 코코를 선택해야 하나요?',
  'product.cocobrick.detail.why.custom.title': '맞춤형 솔루션:',
  'product.cocobrick.detail.why.custom.desc': '다양한 크기와 배합으로 모든 용도에 적합합니다.',
  'product.cocobrick.detail.why.premium.title': '프리미엄 품질:',
  'product.cocobrick.detail.why.premium.desc': '스리랑카 킹코코넛만을 사용한 최고급 제품입니다.',
  'product.cocobrick.detail.why.organic.title': '100% 유기농:',
  'product.cocobrick.detail.why.organic.desc': '화학 처리 없는 천연 재료로 안전합니다.',
  'product.cocobrick.detail.why.proven.title': '검증된 성능:',
  'product.cocobrick.detail.why.proven.desc': '전국 농가에서 검증된 토양 개량 효과를 제공합니다.',
  'product.cocobrick.detail.why.korean.title': '한국 기술:',
  'product.cocobrick.detail.why.korean.desc': '한국 농업대학과의 공동 연구로 개발되었습니다.',
  'product.cocobrick.detail.why.cost.title': '경제적:',
  'product.cocobrick.detail.why.cost.desc': '압축 형태로 보관 및 운송이 편리하고 비용 효율적입니다.',
  'product.cocobrick.detail.cta.title': '지금 바로 문의하세요',
  'product.cocobrick.detail.cta.description': '골든 코코 압축 브릭으로 토양을 개선하고 수확량을 높이세요',
  'product.cocobrick.detail.cta.button': '제품 문의하기',

  // Grow Pole Detail
  'product.growpole.detail.card.organic': '유기농',
  'product.growpole.detail.card.custom': '맞춤 제작',
  'product.growpole.detail.card.eco': '친환경',
  'product.growpole.detail.overview.badge': '식물 지지대',
  'product.growpole.detail.overview.title': '천연 코코넛 섬유 식물 지지대',
  'product.growpole.detail.overview.description': '몬스테라, 필로덴드론 등 덩굴성 식물을 위한 천연 지지대입니다. 코코넛 섬유가 수분을 보유하여 기근 발달을 촉진하고, 자연스러운 외관으로 실내외 어디서나 사용 가능합니다.',
  'product.growpole.detail.learnMore': '상세 정보 보기',
  'product.growpole.detail.showLess': '간단히 보기',
  'product.growpole.detail.features.title': '주요 특징',
  'product.growpole.detail.features.optimal': '덩굴성 식물 최적화',
  'product.growpole.detail.features.optimalDesc': '몬스테라, 필로덴드론 등 덩굴성 식물에 최적',
  'product.growpole.detail.features.custom': '맞춤형 크기',
  'product.growpole.detail.features.customDesc': '다양한 높이와 직경으로 제작 가능',
  'product.growpole.detail.features.chipSize': '천연 섬유',
  'product.growpole.detail.features.chipSizeDesc': '100% 천연 코코넛 섬유 사용',
  'product.growpole.detail.features.organic': '100% 유기농',
  'product.growpole.detail.features.organicDesc': '화학 처리 없는 천연 재료',
  'product.growpole.detail.features.eco': '친환경',
  'product.growpole.detail.features.ecoDesc': '생분해 가능한 천연 재료',
  'product.growpole.detail.features.growth': '기근 발달 촉진',
  'product.growpole.detail.features.growthDesc': '수분 보유로 기근 성장 지원',
  'product.growpole.detail.features.water': '수분 보유',
  'product.growpole.detail.features.waterDesc': '코코넛 섬유가 수분을 보유하여 기근 발달 촉진',
  'product.growpole.detail.features.ph': '안정적인 pH',
  'product.growpole.detail.features.phDesc': 'pH 5.7-6.7 범위 유지',
  'product.growpole.detail.features.ec': '초저 EC',
  'product.growpole.detail.features.ecDesc': 'EC < 0.5 mS/cm',
  'product.growpole.detail.features.drainage': '탁월한 배수성',
  'product.growpole.detail.features.drainageDesc': '과습 방지',
  'product.growpole.detail.features.greenhouse': '실내외 사용',
  'product.growpole.detail.features.greenhouseDesc': '실내 및 온실 모두 사용 가능',
  'product.growpole.detail.features.drainageSlits': '자연스러운 외관',
  'product.growpole.detail.features.drainageSlitsDesc': '인테리어와 조화로운 디자인',
  'product.growpole.detail.features.plantingHoles': '안정적 구조',
  'product.growpole.detail.features.plantingHolesDesc': '튼튼한 지지력 제공',
  'product.growpole.detail.features.dripHoles': '설치 간편',
  'product.growpole.detail.features.dripHolesDesc': '쉽고 빠른 설치',
  'product.growpole.detail.specs.title': '기술 사양',
  'product.growpole.detail.specs.size': '크기',
  'product.growpole.detail.specs.sizeValue': '맞춤 제작',
  'product.growpole.detail.specs.sizeDesc': '다양한 높이와 직경',
  'product.growpole.detail.specs.phRange': 'pH 범위',
  'product.growpole.detail.specs.ec': 'EC 수준',
  'product.growpole.detail.specs.material': '재료',
  'product.growpole.detail.specs.materialValue': '천연 코코넛 섬유',
  'product.growpole.detail.specs.waterRetention': '수분 보유력',
  'product.growpole.detail.specs.waterRetentionValue': '높음',
  'product.growpole.detail.specs.certification': '인증',
  'product.growpole.detail.specs.certificationValue': '유기농',
  'product.growpole.detail.applications.title': '적용 분야',
  'product.growpole.detail.applications.monstera': '몬스테라',
  'product.growpole.detail.applications.climbing': '덩굴성 식물',
  'product.growpole.detail.applications.indoor': '실내 식물',
  'product.growpole.detail.applications.outdoor': '실외 식물',
  'product.growpole.detail.applications.nursery': '육묘장',
  'product.growpole.detail.applications.farm': '농장',
  'product.growpole.detail.why.title': '왜 골든 코코를 선택해야 하나요?',
  'product.growpole.detail.why.natural.title': '천연 재료:',
  'product.growpole.detail.why.natural.desc': '100% 천연 코코넛 섬유로 만든 친환경 제품입니다.',
  'product.growpole.detail.why.premium.title': '프리미엄 품질:',
  'product.growpole.detail.why.premium.desc': '스리랑카 킹코코넛만을 사용한 최고급 제품입니다.',
  'product.growpole.detail.why.custom.title': '맞춤형 솔루션:',
  'product.growpole.detail.why.custom.desc': '식물 크기에 맞춘 다양한 크기로 제작 가능합니다.',
  'product.growpole.detail.why.sustainable.title': '지속 가능:',
  'product.growpole.detail.why.sustainable.desc': '생분해 가능한 친환경 재료입니다.',
  'product.growpole.detail.why.health.title': '식물 건강:',
  'product.growpole.detail.why.health.desc': '수분 보유로 기근 발달을 촉진하여 건강한 성장을 지원합니다.',
  'product.growpole.detail.why.aesthetic.title': '미적 가치:',
  'product.growpole.detail.why.aesthetic.desc': '자연스러운 외관으로 인테리어와 완벽하게 조화됩니다.',
  'product.growpole.detail.why.quote': '"골든 코코 그로우 폴로 아름답고 건강한 덩굴 식물을 키우세요"',

  // Contact Section
  'contact.title': '문의하기',
  'contact.subtitle': '최고의 코코넛 제품에 대해 알아보세요',
  'contact.email': '이메일',
  'contact.phone': '전화',
  'contact.website': '웹사이트',
  'contact.office.title': '본사',
  'contact.office.address': '광주광역시 북구 첨단과기로 208번길 43-10, 2층 (오룡동)',
  'contact.factory.title': '공장',
  'contact.factory.address': '스리랑카 쿠루네갈라',
  'contact.form.name': '이름',
  'contact.form.email': '이메일',
  'contact.form.phone': '전화번호',
  'contact.form.company': '회사명',
  'contact.form.message': '메시지',
  'contact.form.maxChars': '최대 500자',
  'contact.form.submit': '문의 보내기',
  'contact.form.success': '문의가 성공적으로 전송되었습니다!',
  'contact.company': 'Inside Global Co., Ltd.',
  'contact.company.tagline': '프리미엄 코코피트 전문 기업',

  // Footer
  'footer.description': '1,500년 스리랑카 전통과 한국 농업기술이 만든 프리미엄 코코피트. 지속 가능한 농업의 미래를 함께 만들어갑니다.',
  'footer.newsletter.title': '뉴스레터',
  'footer.newsletter.placeholder': '이메일 주소',
  'footer.privacy': '개인정보 처리방침',
  'footer.products.title': '제품',
  'footer.resources.title': '정보',
  'footer.resources.about': '회사소개',
  'footer.resources.technology': '기술',
  'footer.resources.contact': '문의',
  'footer.resources.documentation': '자료실',
  'footer.resources.support': '고객지원',
  'footer.copyright': '© 2024 Inside Global Co., Ltd. All rights reserved.',
  'footer.poweredBy': 'Powered by Readdy',
}
